module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-left-top-backplates-remnants.8206d836.png";